<div app-lomake-62-oy-2026 (tallennaArvo)="lomakeMuuttui($event)" (sulje)="sulje()" [veroilmoitusObservable]="veroilmoitusObservable" class="blue-block"></div>
